var map = {
	"./arrow-left-circle.svg": "./src/icons/svg/arrow-left-circle.svg",
	"./arrow-left.svg": "./src/icons/svg/arrow-left.svg",
	"./arrow-right-circle.svg": "./src/icons/svg/arrow-right-circle.svg",
	"./arrow-right.svg": "./src/icons/svg/arrow-right.svg",
	"./article.svg": "./src/icons/svg/article.svg",
	"./back-to-top.svg": "./src/icons/svg/back-to-top.svg",
	"./category.svg": "./src/icons/svg/category.svg",
	"./chevron.svg": "./src/icons/svg/chevron.svg",
	"./clock-outline.svg": "./src/icons/svg/clock-outline.svg",
	"./clock.svg": "./src/icons/svg/clock.svg",
	"./close.svg": "./src/icons/svg/close.svg",
	"./csdn.svg": "./src/icons/svg/csdn.svg",
	"./date-outline.svg": "./src/icons/svg/date-outline.svg",
	"./date.svg": "./src/icons/svg/date.svg",
	"./dots.svg": "./src/icons/svg/dots.svg",
	"./empty-search.svg": "./src/icons/svg/empty-search.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./folder.svg": "./src/icons/svg/folder.svg",
	"./github.svg": "./src/icons/svg/github.svg",
	"./globe.svg": "./src/icons/svg/globe.svg",
	"./go-back.svg": "./src/icons/svg/go-back.svg",
	"./hot.svg": "./src/icons/svg/hot.svg",
	"./nav-home.svg": "./src/icons/svg/nav-home.svg",
	"./nav-menu.svg": "./src/icons/svg/nav-menu.svg",
	"./nav-top.svg": "./src/icons/svg/nav-top.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./pin.svg": "./src/icons/svg/pin.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./quote.svg": "./src/icons/svg/quote.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./stackoverflow.svg": "./src/icons/svg/stackoverflow.svg",
	"./tag.svg": "./src/icons/svg/tag.svg",
	"./text-outline.svg": "./src/icons/svg/text-outline.svg",
	"./text.svg": "./src/icons/svg/text.svg",
	"./toc.svg": "./src/icons/svg/toc.svg",
	"./twitter.svg": "./src/icons/svg/twitter.svg",
	"./warning.svg": "./src/icons/svg/warning.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./weibo.svg": "./src/icons/svg/weibo.svg",
	"./zhifu.svg": "./src/icons/svg/zhifu.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";